import BilletsYardInventory from "@/pages/billet-yard-inventory";
import { RouteConfig } from "./types";

export const billetYardInventoryRoutes: RouteConfig[] = [
  {
    path: "/billets-yard-inventory",
    element: <BilletsYardInventory />,
    permission: "ui.navbar.byi.billets-yard-inventory", // TODO: change to billets-yard-inventory
  },
  {
    path: "/billets-yard-inventory-touch",
    element: <BilletsYardInventory />,
    permission: "ui.navbar.byi.billets-yard-inventory",
  },
];
